import { SettingTipItem } from './index.d';

export const settingTipList: SettingTipItem[]= [
  {
    icon: 'icon-weixing',
    title: '卫星定位',
    desc: '支持美国GPS、中国北斗两种卫星定位，室外空旷场地，最佳定位精度10米左右，但室内定位效果不佳。',
    isLast: false
  },
  {
    icon: 'icon-wifi',
    title: 'Wi-Fi定位',
    desc: '电子学生证通过Wi-Fi模块，收集周边的Wi-Fi热点信息，来计算出自身的位置信息，定位的精准度最佳在50米以内。',
    isLast: false
  },
  {
    icon: 'icon-jizhan',
    title: '模糊定位',
    desc: '电子学生证通过电信移动运营商的网络（如GSM网），获取自身的位置信息，定位的精准度一般在500米以内。',
    isLast: true
  }
]

export const tipTitle = "温馨提示：";
export const tipContent = "定位过程中，电子学生证会根据当时环境，智能选择最合适的定位方式，用户无须手动选择定位方式。";
